





























































































import { Component, Vue, Prop } from "vue-property-decorator";
import echarts from "echarts";
import wordcloud from "vue-wordcloud";
import { barOption, graphOption } from "@/plugins/echarts.ts";
import {
  GetPapers,
  GetTopics,
  GetPaperStats,
  GetDiseases,
} from "@/request/zsk";
import { forEach } from "lodash";
@Component({
  components: {
    wordcloud,
  },
})
export default class Show extends Vue {
  private messages: any[] = [];
  private jibingText: any = "";
  private diseases: any[] = [];
  private defaultDisease: any = "糖尿病";
  private currentPage = 1;
  private totalPage = 1;
  private selectTime = "最近10年";
  private authorData: any[] = [];
  private wordcloudData: any[] = [];
  private wordcloudColors: any[] = [
    "#3399cc",
    "#fbbe49",
    "#3b9987",
    "#d48265",
    "#c23531",
    "#91c7ae",
    "#8fb9e4",
    "#d83bd3",
    "#79dd79",
    "#fd8888",
  ];
  @Prop()
  private searchText;
  /**
   * @description 跳转详情
   */
  private goToDetail(item) {
    this.$router.push({
      path: "/main/zsk/shezhen-detail",
      query: {
        id: item.paper_id,
      },
    });
  }
  /**
   * @description 获取最新文献列表
   */
  private getList(page?) {
    if (page) {
      this.currentPage = page;
    }
    const params = {
      search: this.searchText,
      current_page: this.currentPage,
      page_count: 5,
    };
    GetPapers(this, params).then((data) => {
      this.totalPage = data.total_page;
      this.messages = data.papers;
    });
  }
  /**
   * @description 最新文献换一批
   */
  private change() {
    if (this.currentPage === this.totalPage) {
      this.currentPage = 1;
    } else {
      this.currentPage++;
    }
    this.getList();
  }
  /**
   * @description 文献热点
   */
  private getWordcloud() {
    GetTopics(this).then((data) => {
      this.wordcloudData = data.data;
    });
  }
  /**
   * @description 获取疾病列表
   */
  private getDiseases(text) {
    const params = {
      params: {
        search: text,
      },
    };
    GetDiseases(this, params).then((data) => {
      this.diseases = data;
    });
  }
  /**
   * @description 文献分析：时间统计、作者图谱
   */
  private getPaperStats() {
    const params = {
      search: this.jibingText || this.defaultDisease,
      时段: this.selectTime,
    };
    GetPaperStats(this, params).then((data) => {
      console.log(data);
      this.authorData = data.authors;
      const Chart = echarts.init(this.$refs.echarts as HTMLCanvasElement);
      const option = JSON.parse(JSON.stringify(barOption));
      option.title.text = "文献数量";
      option.xAxis[0].data = data.table.name;
      option.series[0].data = data.table.data;

      option.color = ["#84CE4A"];
      Chart.setOption(option);

      this.getAuthorTu(data["作者图谱"]);
    });
  }
  private getAuthorTu(data: any) {
    const Chart = echarts.init(this.$refs.echarts2 as HTMLCanvasElement);
    const option = JSON.parse(JSON.stringify(graphOption));
    option.color = ["#5AA0FF", "#90C956", "#FFE199", "#B0DA86", "#BAD9FF"];
    option.tooltip = {
      show: true,
      formatter: (p: any) => {
        return p.data.name_display;
      },
    };
    option.series[0].data = data.nodes;
    option.series[0].links = data.links;
    option.series[0].categories = data.categories;
    option.series[0].nodeScaleRatio = 0;
    option.series[0].symbolSize = 40;
    option.series[0].label = {
      show: true,
      position: "inside",
      color: "#fff",
      formatter: (p: any) => {
        return p.data.name_display;
      },
    };
    option.series[0].force = {
      repulsion: 150,
      edgeLength: 100,
    };
    Chart.setOption(option);
  }
  private mounted() {
    this.getList();
    this.getWordcloud();
    this.getPaperStats();
  }
}
